/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Channelconfirmbody2Inputs */

const en_channelconfirmbody2 = /** @type {(inputs: Channelconfirmbody2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This message will be sent to ${i?.count} users as a Pulsify chat message.`)
};

const de_channelconfirmbody2 = /** @type {(inputs: Channelconfirmbody2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diese Nachricht wird an ${i?.count} Nutzer als Pulsify-Chat-Nachricht gesendet.`)
};

/**
* | output |
* | --- |
* | "This message will be sent to {count} users as a Pulsify chat message." |
*
* @param {Channelconfirmbody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelconfirmbody2 = /** @type {((inputs: Channelconfirmbody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelconfirmbody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelconfirmbody2(inputs)
	return de_channelconfirmbody2(inputs)
});
export { channelconfirmbody2 as "channelConfirmBody" }